'use client';
import Image from 'next/image';
import Link from 'next/link';
import { useTheme } from 'next-themes';
import { useEffect, useState } from 'react';

import { cn } from '@/lib/utils';
import { paths } from '@/constants/paths';

import { appConfig } from '@/config/app';

type Props = {
  className?: string;
  width?: number;
  containerStyles?: string;
  linkStyles?: string;
};

const Logo = ({
  className,
  width = 240,
  containerStyles,
  linkStyles,
}: Props) => {
  const heightMultiplier = 278 / 2323;
  const { theme } = useTheme();
  const isDark = theme === 'dark';
  const [logo, setLogo] = useState<string>(appConfig.logo);
  useEffect(() => {
    setLogo(isDark ? appConfig.logoDark : appConfig.logo);
  }, [isDark]);
  return (
    <div className={cn('flex h-fit w-fit justify-center', containerStyles)}>
      <Link href={paths.dashboard.index} className={cn(linkStyles)}>
        <Image
          src={logo}
          alt='Logo'
          height={width * heightMultiplier}
          width={width}
          className={cn(className)}
        />
      </Link>
    </div>
  );
};

export default Logo;
